import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "../components/Modal";
import {Button, Input} from 'styled'
import getFormattedDate, { formatDate } from "utils/helpers";

const VehicleEnrollmentDetails = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const getData = async ()=>{
    setIsLoading(true)
    try{
    const dt = await   createDocument("/report/vehicleEnrollmentDetails", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
          dateFrom,
          dateTo,
    })
    // console.log(dt)
    setData(dt);
  }catch(err){

  }
    setIsLoading(false)
  }

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  let finalData = data?.data;

  const getDownloadData = async () => {
    setDownloading(true);
    try {
      const dt = await createDocument("/report/vehicleEnrollmentDetails/download", {
        dateFrom,
        dateTo,
        ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      });
      // console.log(dt);
      if (dt?.data) setReportData(dt.data);

      let finalData = dt?.data;
      
      let exportData = finalData?.map((x, idx) => ({
          "S.N": idx + 1,
          "Fleet Name": x.fleetName ? `${x.fleetName} (${x.fleetCity || "--"})` : "--",
          // "Fitment Date": x?.fitmentDate ? new Date(x.fitmentDate).toLocaleDateString("en-GB") : "--",
          Service: x?.Service,
          CPKM: x?.CPKM,
          "Total Vehicle": x?.vehicles,
          "CPKM Enrolment %": x?.CPKMEnrollmentPercentage,
        }))

      let totalRow = {
        CPKM: dt.totalRow.CPKM,
        Service: dt.totalRow.Service,
        "CPKM Enrolment %": dt.totalRow.CPKMEnrollmentPercentage,
        "Total Vehicle": dt.totalRow.vehicles,
        "S.N": "Total"
      }
      
      exportData.push(totalRow)


      exportExcel(exportData, "vehicleEnrollmentDetails", true)
      
    } catch (err) {
      console.log(err)
    }
    setDownloading(false);
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="w-full px-8 flex flex-wrap lg:flex-nowrap justify-start items-end gap-4">
        <label className="w-full py-3 flex flex-col gap-2">
          Select Fleets
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find(
                    (item) => item?.value === fleet
                  )?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if (allValues?.includes("clear")) {
                // console.log(allValues)
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if (
                !selectedFleets?.includes("all") &&
                allValues.includes("all")
              ) {
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter((item) => item.value !== "all");
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );

              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({allHubs, selectedHubs})

              setSelectedFleets(value.map((fleet) => fleet.value));
            }}
            name="fleets"
            isMulti={true}
          />
        </label>
        <label className="w-full py-3 flex flex-col gap-2">
          Select Hubs
          <ReactSelect
            styles={filterSelectStyles}
            className="shadow-md rounded-md"
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                // console.log({hub})
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({allValues})
              if (allValues.includes("clear")) {
                setSelectedHubs([]);
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  selectedFleetCodes?.includes(hub.fleetCode)
                );

                const mp = fleetMap;
                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                setFleetMap(mp);
                setSelectedHubs(["all"]);
              } else {
                // console.log({value})
                value = value.filter((value) => value.value !== "all");
                // console.log({value})
                let selectedFleetCodes = allFleets?.data
                  ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                  ?.map((fleet) => fleet.fleetCode);
                // console.log({allValues})

                const selectedHubsData = allHubs?.data?.filter((hub) =>
                  allValues?.includes(hub._id)
                );
                const mp = {};
                selectedHubsData.map((hub) => {
                  mp[hub.fleetCode] = [];
                });

                selectedHubsData.map((hub) => {
                  if (selectedFleetCodes?.includes(hub.fleetCode)) {
                    if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                  }
                });

                setFleetMap(mp);
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>
        <label className="w-full py-3 flex flex-col gap-2">
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            End Date{" "}
            <Input
              type="date"
              min={dateFrom ? getFormattedDate(dateFrom) : undefined}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>

        <div className="flex items-end justify-end gap-2 mb-3">
          <Button
            type="button"
            disabled={selectedFleets.length == 0 || selectedHubs.length === 0}
            bgPrimary
            onClick={() => getData()}
          >
            Search
          </Button>

          {downloading
            ? "Downloading..."
            : selectedHubs.length > 0 && (
                <BiCloudDownload
                  className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                  onClick={async () => {
                    await getDownloadData();
                    // if(reportData){
                    // console.log({reportData})
                    // }
                  }}
                />
              )}
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Fleet Name</TH>
                      <TH scope="col">CPKM</TH>
                      <TH scope="col">Service</TH>
                      <TH scope="col">Total Vehicles</TH>
                      <TH scope="col">CPKM Enrolment %</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {finalData &&
                      finalData?.map((d, idx) => (
                        <ViewList 
                          data={d} 
                          idx={idx}
                          selectedFleets={selectedFleets}
                          selectedHubs={selectedHubs}
                          dateFrom={dateFrom}
                          dateTo={dateTo}
                          getFleetOptions={getFleetOptions}
                          getHubOptions={getHubOptions}
                          allFleets={allFleets}
                          allHubs={allHubs}
                        />
                      ))}
                  </tbody>
                  {data?.totalRow ? (
                    <tfoot>
                      <tr className="text-gray-600 font-semibold bg-green-100">
                        <TD></TD>
                        <TD  className="text-left">
                          TOTAL
                        </TD>
                        <TD  className="">{data?.totalRow?.CPKM}</TD>
                        <TD className="">{data?.totalRow?.Service}</TD>
                        <TD className="">{data?.totalRow?.total}</TD>
                        <TD className="">{data?.totalRow?.CPKMEnrollmentPercentage}</TD>
                      </tr>
                    </tfoot>
                  ) : (
                    <></>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleEnrollmentDetails;

const ViewList = ({ data, idx, selectedFleets, selectedHubs, dateFrom, dateTo, getFleetOptions, getHubOptions, allFleets, allHubs }) => {

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const modalHandler = useCallback(
    (data) => {
      if (data) {
        setModalData(data);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData([]);
      }
    },
    [showModal, modalData]
  );

  // Get fleetId from fleetCode
  const getFleetIdFromCode = (fleetCode) => {
    if (!allFleets?.data || !fleetCode) return null;
    const fleet = allFleets.data.find(f => f.fleetCode === fleetCode);
    return fleet?._id || null;
  };

  // Get hubs for a specific fleet
  const getHubsForFleet = (fleetCode) => {
    if (!allHubs?.data || !fleetCode) return [];
    return allHubs.data
      .filter(hub => hub.fleetCode === fleetCode)
      .map(hub => hub._id);
  };
  
  const getModalHubsForFleet = (fleetCode) => {
    const fleetHubs = getHubsForFleet(fleetCode);
    if (!selectedHubs?.length || selectedHubs.includes("all")) {
      return fleetHubs;
    }
    return fleetHubs.filter((hubId) => selectedHubs.includes(hubId));
  };
  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={"Vehicle Information"}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          <h1 className="w-full flex justify-end text-end px-2 my-1">
            <Button
              onClick={() => {
                exportExcel(
                  modalData?.data?.map((x, idx) => ({
                    "S.N": idx + 1,
                    "Vehicle Number": x?.registrationNumber,
                    "Vehicle Configuration": x?.configurationName,
                    "Fitment Date": formatDate(x?.fitmentDate, '-'),
                    "Last Inspection Date": x?.lastInspectionDate,
                    "Last Inspection By": x?.lastInspectionBy,
                    "No of Tyres": x?.tyrePositionsSize,
                    // x?.lastInspectionDate,
                  })),
                  modalData.title.split(" ").join("_") + "_Data"
                );
                 
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              Download
            </Button>
            </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Vehicle Number</TH>
                <TH scope="col">Vehicle Configuration</TH>
                <TH scope="col">Fitment Date</TH>
                <TH scope="col">Last Inspection Date</TH>
                <TH scope="col">Last Inspection By</TH>
                <TH scope="col">No of Tyres</TH>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {modalData &&
                modalData?.data?.map((d, idx) => {
                  // console.log(typeof d.vehicle.lastInspectionDate);
                  return (
                    <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
                      <TD>{idx + 1}</TD>
                      <TD>{d?.registrationNumber}</TD>
                      <TD>{d?.configurationName}</TD>
                      <TD>{formatDate(d?.fitmentDate,'-')}</TD>
                      <TD>
                        {d?.lastInspectionDate}
                      </TD>
                      <TD>
                        {d?.lastInspectionBy}
                      </TD>
                      <TD>
                        {d?.tyrePositionsSize}
                      </TD>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{data?.fleetName ? `${data.fleetName} (${data.fleetCity || "--"})` : "--"}</TD>
        <TD>
          <div className="flex gap-2 items-center justify-start">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={async () => {
                try {
                  const fleetId = getFleetIdFromCode(data?.fleetCode);
                  const hubs = getModalHubsForFleet(data?.fleetCode);
                  const requestBody = {
                    dateFrom,
                    dateTo,
                    fleets: fleetId,
                    ...(hubs.length > 0 && { hubs: hubs.join(",") }),
                    contractType: "CPKM",
                  };
                  console.log("Modal request data:", requestBody, "Row data:", data);
                  const modalResponse = await createDocument("/report/vehicleEnrollmentDetails/modalInfo", requestBody);
                  modalHandler({
                    data: modalResponse.data || [],
                    title: `Enrolled Vehicles ${data?.fleetName} (${data?.fleetCity || "--"}) CPKM`
                  });
                } catch (err) {
                  console.error("Error fetching modal data:", err);
                }
              }}
            >
              {data?.CPKMCount || 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-start">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={async () => {
                try {
                  const fleetId = getFleetIdFromCode(data?.fleetCode);
                  const hubs = getModalHubsForFleet(data?.fleetCode);
                  const modalResponse = await createDocument("/report/vehicleEnrollmentDetails/modalInfo", {
                    dateFrom,
                    dateTo,
                    fleets: fleetId,
                    ...(hubs.length > 0 && { hubs: hubs.join(",") }),
                    contractType: "Service",
                  });
                  modalHandler({
                    data: modalResponse.data || [],
                    title: `Enrolled Vehicles ${data?.fleetName} (${data?.fleetCity || "--"}) Service`
                  });
                } catch (err) {
                  console.error("Error fetching modal data:", err);
                }
              }}
            >
              {data?.ServiceCount || 0}
            </span>
          </div>
        </TD>
        <TD>
          <div className="flex gap-2 items-center justify-start">
            <span
              className="hover:text-green-500 cursor-pointer"
              onClick={async () => {
                try {
                  const fleetId = getFleetIdFromCode(data?.fleetCode);
                  const hubs = getModalHubsForFleet(data?.fleetCode);
                  const modalResponse = await createDocument("/report/vehicleEnrollmentDetails/modalInfo", {
                    dateFrom,
                    dateTo,
                    fleets: fleetId,
                    ...(hubs.length > 0 && { hubs: hubs.join(",") }),
                  });
                  modalHandler({
                    data: modalResponse.data || [],
                    title: `Enrolled Vehicles ${data?.fleetName} (${data?.fleetCity || "--"}) Total`
                  });
                } catch (err) {
                  console.error("Error fetching modal data:", err);
                }
              }}
            >
              {data?.vehiclesCount || 0}
            </span>
          </div>
        </TD>

        <TD>
          <div className="flex gap-2 items-center justify-start">
            <span
              className="hover:text-green-500 cursor-pointer"
            >
              {data?.CPKMEnrollmentPercentage || 0}
            </span>
          </div>
        </TD>
      </tr>
    </Fragment>
  );
};
